import { css } from '@/styled-system/css';

export const popoverBodyStyles = css.raw({
  paddingBlock: 'Popover.Body.padding.vert',
  paddingInline: 'Popover.Body.padding.horz',
  overflowY: 'auto',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 'auto',
});
